export default {
      id: "button_units_on_map-usage",
      viewBox: "0 0 21 23",
      url: __webpack_public_path__ + "img/icons.svg#button_units_on_map",
      toString: function () {
        return this.url;
      }
    }